import React from  'react'
import PropTypes from 'prop-types'
import './ModalPopup.css'

/**
 * A react component that will wrap it's children in a modal popup.
 * It can be closed by clicking anywhere outside the popup
 */
const ModalPopup = (props) => {
	const size = {width: props.width}
	const style = {display: props.visible ? 'block' : 'none'}
	return (
		<div className="modal" style={style} onClick={() => props.close()}>
			<div className="content" style={size} onClick={(evt) => evt.stopPropagation()}>
				{props.children}
			</div>
		</div>
	)
}

ModalPopup.propTypes = {
	/** The width of the popup */
	width: PropTypes.string,
	/** The id of the popup which distinguishes it from other popups */
	id: PropTypes.string.isRequired,
	/** The function that should be called to close this popup */
	close: PropTypes.func.isRequired,
}

export default ModalPopup


// WEBPACK FOOTER //
// ./src/components/ModalPopup/ModalPopup.js